module.exports = __webpack_public_path__ + "img/new_index_cases12.f10a8985.png";